export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
export const GET_FETCH_DATA = 'GET_FETCH_DATA'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
